import React from "react";

type BottomModalProps = {
    title?: string | React.ReactNode;
    onClose: () => void;
    onConfirm?: () => void;
    children?: React.ReactNode;
    isOpen?: boolean;
};

export const BottomModal = ({
    title = "Đăng xuất",
    children,
    onClose,
    isOpen = true
}: BottomModalProps) => {
    return (
        <div className="fixed inset-0 z-50 flex items-end justify-end bg-black/40 pl-16 pt-24">
            <div className={`bg-white w-full rounded shadow-lg overflow-y-auto h-[90%] mt-20 ${isOpen ? 'animate-modal-up' : 'animate-modal-down'}`}>

                {/* Header */}
                <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200">
                    <h3 className="text-lg font-semibold">{title}</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 text-xl leading-none pr-2"
                    >
                        &times;
                    </button>
                </div>

                <div>
                    {children}
                </div>

            </div>
        </div>
    );
};
